{
  "hu-HU": {
    "model": {
      "profile": {
        "id": "Felhasználói azonosító",
        "userName": "Felhasználónév",
        "email": "E-mail cím",
        "emailConfirmed": "E-mail cím megerősítve",
        "phoneNumber": "Telefonszám",
        "phoneNumberConfirmed": "A telefonszám megerősítve.",
        "twoFactorEnabled": "A kétfaktoros hitelesítés engedélyezve.",
        "lockoutEnd": "A zárolás vége.",
        "lockoutEnabled": "A zárolás engedélyezve.",
        "accessFailedCount": "Sikertelen bejelentkezési kísérletek száma",
        "firstName": "Keresztnev",
        "lastName": "Családnév",
        "picture": "Profilkép",
        "organisationName": "Szervezet",
        "name": "Név",
        "roles": "Szerepkörök"
      }
    },
    "profileManager": {
      "column": {
        "emailConfirmed": "Megerősítve"
      },
      "action": {
        "resetPassword.tooltip": "Küldjön jelszó-visszaállítási útmutatót az felhasználónak e-mailben."
      },
      "message": {
        "resetPassword.success": "A felhasználónak e-mailt küldtünk, amelyben tájékoztatjuk arról, hogyan állíthatja vissza a jelszavát."
      }
    }
  }
}